/*
* Component to render <options> used in <select> (needed for react-redux-form)
* note: options property must pass an Array<any> of objects with type ISelectListOptionsListItem
*/

import * as React from 'react';
import * as _ from 'lodash';

import * as AppUtilities from './apputilities';

export interface ISelectOptionsListItem {
    disabled: boolean;
    label: string;
    value: any;
}

export class SelectOptionsListItem implements ISelectOptionsListItem {
    public disabled: boolean = false;
    public label: string = '';
    public value: any = '';

    public constructor(label: string = '', value: any = '', disabled: boolean = false) {
        this.label = label;
        this.value = value;
        this.disabled = disabled;
    }
}

export interface ISelectOptionsProps {
    disabledField: string;
    labelField: string;
    options: Array<SelectOptionsListItem>;
    valueField: string;
}

export class SelectOptions extends React.Component<ISelectOptionsProps, any> {
    public static defaultProps = {
        disabledField: 'disabled',
        labelField: 'label',
        options: [],
        valueField: 'value',
    };

    public static prepareSelectOptions(records: Array<any>, nameField: string = 'name', valueField: string = 'value', sortField: string = 'sort', disabledField: string = 'disabled', sortByField: string = '',
                                       placeholderText: string = '', placeholderValue: any = '', placeholderSortValue: any = '',
                                       addPlaceholderOption: boolean = true, placeholderOptionDisabled: boolean = true, optionValuesAsStrings: boolean = false): Array<SelectOptionsListItem> {
        // Return array of SelectOptionListItems for use as <SelectOption options={blah}>

        let result: Array<SelectOptionsListItem> = [];

        if (AppUtilities.isArrayWithLength(records)) {
            let recordsExtended = _.cloneDeep(records);

            // Attach sort fields if missing
            if (sortField && sortByField) {
                recordsExtended.forEach(c => {
                    if (!_.has(c, sortField)) {
                        c = _.set(c, `sort_${sortField}`, _.get(c, sortByField, ''));
                        // c = _.set(c, sortField, _.get(c, sortByField, ''));
                    }
                });
            }

            if (addPlaceholderOption) {
                // Add default placeholder option
                let placeholderOption = {};

                placeholderOption = _.set(placeholderOption, nameField, placeholderText);
                placeholderOption = _.set(placeholderOption, valueField, placeholderValue);
                placeholderOption = _.set(placeholderOption, disabledField, placeholderOptionDisabled);
                if (sortField) { placeholderOption = _.set(placeholderOption, sortField, placeholderSortValue); }

                recordsExtended.push(placeholderOption);
            }

            // Sort options if needed
            let sortedRecords = sortField ? _.sortBy(recordsExtended, [sortField]) : recordsExtended;

            // Iterate records and create SelectOptionsListItems
            result = sortedRecords.map(c => {
                let val = _.get(c, valueField);

                if (optionValuesAsStrings) {
                    val = val.toString();
                }

                return new SelectOptionsListItem(_.get(c, nameField), val, _.get(c, disabledField, false));
            });
        }

        return result;
    }

    public static prepareSelectOptionsNew(records: Array<any>, nameField: string = 'name', valueField: string = 'value', sortField: string = 'sort', disabledField: string = 'disabled', sortByField: string = '',
                                          placeholderText: string = '', placeholderValue: any = '', placeholderSortValue: any = '',
                                          addPlaceholderOption: boolean = true, placeholderOptionDisabled: boolean = true, optionValuesAsStrings: boolean = true): Array<SelectOptionsListItem> {
        // Return array of SelectOptionListItems for use as <SelectOption options={blah}>
        // console.log(`prepareSelectOptionsNew sortField ${sortField} sortByField ${sortByField}`, records);

        let result: Array<SelectOptionsListItem> = [];

        if (AppUtilities.isArrayWithLength(records)) {
            let recordsExtended = _.cloneDeep(records);

            // Attach sort fields if missing
            if (sortField && sortByField) {
                recordsExtended.forEach(c => {
                    if (!_.has(c, sortField)) {
                        c = _.set(c, `sort_${sortField}`, _.get(c, sortByField, ''));
                    }
                });
            }

            // Sort options if needed
            let sortedRecords = sortField ? _.sortBy(recordsExtended, [sortField]) : recordsExtended;

            if (addPlaceholderOption) {
                // Add default placeholder option
                let placeholderOption = {};

                placeholderOption = _.set(placeholderOption, nameField, placeholderText);
                placeholderOption = _.set(placeholderOption, valueField, placeholderValue);
                placeholderOption = _.set(placeholderOption, disabledField, placeholderOptionDisabled);
                if (sortField) { placeholderOption = _.set(placeholderOption, sortField, placeholderSortValue); }

                sortedRecords.unshift(placeholderOption);
            }

            // Iterate records and create SelectOptionsListItems
            result = sortedRecords.map(c => {
                let val = _.get(c, valueField);

                if (optionValuesAsStrings) {
                    val = String(val); // .toString();
                }

                return new SelectOptionsListItem(_.get(c, nameField), val, _.get(c, disabledField, false));
            });
        }

        return result;
    }

    public constructor(props: ISelectOptionsProps) {
        super(props);
    }

    public render() {
        const { disabledField, labelField, valueField, options, ...rest } = this.props;

        return options.map((v, i) => {
            return (<option key={i} disabled={_.get(v, disabledField)} value={_.get(v, valueField)}>{_.get(v, labelField)}</option>);
        });
    }
}



// WEBPACK FOOTER //
// ./src/common/selectOptions.tsx